import React, { useState, useEffect, useContext } from "react";

import { HalfYearContext } from "../../../../contexts/halfYearContext";

import DataTable from "./TypeListTable";
import MainTitle from "../../../common/MainTitle";
import MainButton from "../../../common/MainButton";
import TableMainSearch from "../../../common/MainSearch";

import db from "../../../../services/query";
import lbl from "../../../../data/Labels.json";

const TypeList = (props) => {
  const [data, setData] = useState([]);
  const [query, setQuery] = useState("");

  const { halfYear } = useContext(HalfYearContext);

  useEffect(() => {
    const ac = new AbortController();

    requestData({ halfYear });

    return () => ac.abort();
  }, [halfYear]);

  const requestData = async (p = new Object()) => {
    try {
      const { halfYear } = p;
      const { tid } = props.match.params;

      let query = `students/discounts/types/${tid}/list?halfYearId=${halfYear}`;

      await db.getAll(query).then(({ data }) => {
        console.log(data);
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainButton type="back" />
          <MainTitle title={data?.summary?.title} />
        </div>
        <div className="center-content">
          <TableMainSearch setQuery={setQuery} />
        </div>
        <div className="left-content"></div>
      </div>
      <div className="main-content-body">
        <DataTable data={data} {...props} query={query} />
      </div>
    </div>
  );
};

export default TypeList;
